/**
 * These keys are used in conjunction with the `useVisibilityRules()` hook.
 * Each key is saved in session storage, and its value determines how form
 * fields are defined within the schema rules.
 */
export const UI_CONDITION_KEYS = {
  IS_AUTH: 'isAuthenticated',
  RESERVE_OFFER_FLOW: 'isReserveOfferFlow',
  EMAIL_AND_NO_ACCOUNT: 'emailExists_NoAccountCreated',
  EMAIL_AND_ACCOUNT: 'emailExists_AccountCreated',
  PIN_EXISTS: 'pinExists',
  SHOULD_BLOCK_PIN_OR_EMAIL_CHECK: 'shouldBlockPinOrEmailCheck',
} as const;

export type UIConditionKey =
  (typeof UI_CONDITION_KEYS)[keyof typeof UI_CONDITION_KEYS];
